import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationsService } from 'core/services/configurations.service';
import { LocalesService } from 'core/services/locales.service';

@Component({
  selector: 'lms-agent-create',
  templateUrl: './agent-create.component.html',
  styleUrls: ['./agent-create.component.scss']
})
export class AgentCreateComponent implements OnInit {
  public tooltips: any = null;
  constructor(
    public location: Location,
    public router: Router,
    public translate: TranslateService,
    private localesService: LocalesService,
    private configurationsService: ConfigurationsService
  ) {}

  ngOnInit() {
    this.configurationsService
      .getInfoMessage$(
        'toolTip',
        'fields.keys[match]',
        'agents.create',
        'textoDeAyuda',
        this.localesService.getBrowserLocale()
      )
      .subscribe((tooltipsMap) => {
        this.tooltips = tooltipsMap;
      });
  }

  onSave(event: CustomEvent): void {
    this.router.navigate(['/agents', event.detail.id], { replaceUrl: true });
  }

  cancel(): void {
    this.location.back();
  }
}
